export default {
  color: {
    text: '#FFF',
    background: '#000'
  },
};



// WEBPACK FOOTER //
// ./src/themes/defaultTheme.ts